export const removeCookie = ({
  name,
  domain,
}: {
  name: string;
  domain?: string;
}) => {
  if (typeof document === 'undefined') {
    return;
  }

  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${
    domain ? `; domain=${domain}` : ''
  }`;
};
